import { ServiceType, CacheBackTypeEnum, OrderType } from '@/types';
import styles from './serviceInfo.module.scss';
import { Button, message } from 'antd';
import { IoShareSocialOutline } from 'react-icons/io5';
import { FaStar } from 'react-icons/fa';
import Image from 'next/image';
import Subtract from '@/assets/images/Subtract3.svg';
import { GlobalContext } from '@/context';
import { useContext, useEffect, useRef, useState } from 'react';
import { COLORS } from '@/utilities';
import { API, PATH } from '@/data';
import { CopyToClipboard, RestAPI, useAsyncClick, useEventListener } from '@/scripts';
import { AppLinkComp, SuccessOfferBuyModalComp } from '@/components';
import Link from 'next/link';
function ServiceInfoComp({
  data
}: {
  data: ServiceType;
}) {
  const [serviceData, setServiceData] = useState<ServiceType>(data);
  const [orderData, setOrderData] = useState<OrderType>();
  const stars: number[] = [1, 2, 3, 4, 5];
  const {
    langText,
    location
  } = useContext(GlobalContext);
  const lang = langText.serviceInfo;
  const language = langText.lang;
  const [printable, setPrintable] = useState(false);
  const timer = useRef<NodeJS.Timeout>();
  const [loading, setLoading] = useState(false);
  const dataSent = useRef(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const profile = useContext(GlobalContext).profile;
  const handleCopyToClipboard = () => {
    CopyToClipboard(window.location.href);
    message.success(lang.copy_alert);
  };
  const print = () => {
    if (dataSent.current) {
      setLoading(false);
      clearInterval(timer.current);
      timer.current = undefined;
      iframeRef.current?.contentWindow?.focus();
      iframeRef.current?.contentWindow?.print();
    } else setLoading(true);
  };
  const getOrder = useAsyncClick(() => {
    if (!profile && serviceData.is_ordered !== 1) return;
    return new Promise(resolve => {
      RestAPI.post<OrderType>(API.order.init, {
        service: serviceData.id
      }).then(res => {
        message.success(lang.create_service_success);
        setServiceData(e => ({
          ...e,
          is_ordered: 1
        }));
        setOrderData(res.data);
      }).catch(() => message.error(lang.create_service_error)).finally(() => resolve(true));
    });
  });
  useEffect(() => {
    if (printable && !dataSent.current && orderData) {
      iframeRef.current?.contentWindow?.postMessage(JSON.stringify({
        service: orderData?.service,
        order: orderData
      }), '*');
      dataSent.current = true;
    }
  }, [printable, data, orderData]);
  useEffect(() => {
    if (loading) timer.current = setInterval(print, 500);
  }, [loading]);
  useEventListener('message', event => {
    if (event.data === 'PRINT_IFRAME_LOADED') setPrintable(true);
  });
  return <div className={`${styles['info']} d-flex flex-column ph-4 pv-3 ${!serviceData.gallery || serviceData.gallery.length === 0 ? styles['full-width'] : ''}`} data-sentry-component="ServiceInfoComp" data-sentry-source-file="serviceInfo.index.tsx">
            <SuccessOfferBuyModalComp data={data} order={orderData} open={!!orderData} onClose={() => setOrderData(undefined)} printable={printable} onPrint={print} data-sentry-element="SuccessOfferBuyModalComp" data-sentry-source-file="serviceInfo.index.tsx" />
            <iframe src={PATH(langText.lang).orderPrint} style={{
      width: '100%',
      height: 0,
      opacity: 0
    }} ref={iframeRef} />
            <div className={`${styles['title-header']} d-flex justify-content-between align-items-center`}>
                <div className="w-100">
                    <span className="d-flex justify-content-between align-items-center">
                        <div className="gap-8">
                            {serviceData.categories?.map(category => <a key={category.id} target="_blank" href={PATH(language).services.category(location.slug, category.slug)} className="t-p2 t-500 t-primary mb-1">
                                    {category.title}
                                </a>)}
                            <span className="t-dark5">|</span>
                            {data.locations?.map(loc => <p key={loc.id} className="t-primary t-p2 t-500">
                                    {loc.name}
                                </p>)}
                        </div>
                        <p className="d-none d-pre-md-flex gap-8 t-p2 t-400 t-dark4" onClick={handleCopyToClipboard}>
                            <IoShareSocialOutline size={18} data-sentry-element="IoShareSocialOutline" data-sentry-source-file="serviceInfo.index.tsx" /> {lang.share}
                        </p>
                    </span>
                    <h3 className="t-800 t-dark1 t-h3">{serviceData.title}</h3>
                </div>
                <Button type="primary" className="d-pre-md-none-i" onClick={handleCopyToClipboard} data-sentry-element="Button" data-sentry-source-file="serviceInfo.index.tsx">
                    <IoShareSocialOutline size={24} data-sentry-element="IoShareSocialOutline" data-sentry-source-file="serviceInfo.index.tsx" />
                </Button>
            </div>
            <span className={`${styles['stars']} d-flex align-items-center`}>
                {data.avg_star && stars.map(star => <FaStar key={star} size={12}
      // color={star <= +serviceData.average_stars.toFixed(1) ? COLORS.primary : COLORS.dark5}
      color={serviceData.avg_star !== undefined ? star <= +serviceData.avg_star?.toFixed(1) ? COLORS.primary : COLORS.dark5 : COLORS.dark5} />)}
                <p className="t-400 t-p1 t-primary">{serviceData.avg_star?.toFixed(1)}</p>
                <p className="t-p2 t-400 t-dark4 mr-1">
                    {serviceData.total_orders} {lang.sale}
                </p>
            </span>
            <div className={`${styles['service-items']} d-flex align-items-center justify-content-between mt-3 pv-2 ph-3`}>
                <div>
                    <p className="t-400 t-p1">{lang.title_desc}</p>
                    <ul className="ph-3">
                        <li className={`t-700 t-h4 ${!serviceData.cash_back ? 'd-none' : ''}`}>
                            {serviceData.cash_back}
                            {serviceData.cash_back_type === CacheBackTypeEnum.constant ? '$' : '%'}{' '}
                            {serviceData.cash_back_type === CacheBackTypeEnum.constant ? lang.refund : lang.refund_percent}
                        </li>
                        {serviceData.extra_service?.map((service, index) => <li key={index} className="t-700 t-h4">
                                {service}
                            </li>)}
                    </ul>
                </div>
                <Image src={Subtract} alt="Subtract" width={95} height={95} data-sentry-element="Image" data-sentry-source-file="serviceInfo.index.tsx" />
            </div>
            <div className={`${styles['brand-prof']} d-flex gap-16 align-items-center mt-3-i`}>
                <div className="d-flex justify-content-center align-items-center gap-16">
                    <Link href={PATH(language).brand(serviceData.brand.slug)} target="blank" data-sentry-element="Link" data-sentry-source-file="serviceInfo.index.tsx">
                        {serviceData.brand.main_image?.file.length && <Image src={serviceData.brand.main_image.file} alt={serviceData.brand.main_image.alt ?? 'service info'} width={50} height={50} />}
                    </Link>
                    <span>
                        <a target="_blank" href={PATH(language).brand(serviceData.brand.slug)} className="t-p1 t-600 t-dark2">
                            {serviceData.brand.title}
                        </a>
                        <span className="d-flex gap-8 align-items-center">
                            <p className="t-p1 t-400 t-primary">
                                <FaStar size={12} data-sentry-element="FaStar" data-sentry-source-file="serviceInfo.index.tsx" /> {serviceData.brand.average_stars?.toFixed(1)}
                            </p>
                            <p className="t-dark4 t-400 t-p2">
                                {serviceData.brand.total_orders} {lang.sale}
                            </p>
                        </span>
                    </span>
                </div>
                {!profile ? <AppLinkComp className={`${styles['get-service-btn']}`} href={PATH(language).login(PATH(language).services.detail(serviceData))}>
                        <Button disabled={!serviceData.is_active || !serviceData.brand.is_active} className="w-100">
                            {lang.receive_services}
                        </Button>
                    </AppLinkComp> : <Button disabled={!!serviceData.is_ordered || !serviceData.is_active || !serviceData.brand.is_active} {...getOrder} className={`${styles['get-service-btn']}`}>
                        {!serviceData.is_ordered ? lang.receive_services : lang.selected}
                    </Button>}
            </div>
        </div>;
}
export default ServiceInfoComp;